import BaseModel from './BaseModel'
import {makeObservable, observable} from 'mobx'

export default class BillingGroup extends BaseModel {
    constructor() {
        super()

        makeObservable(this, {
            id: observable,
            company_id: observable,
            billing_type_id: observable,
            billing_type: observable,
            name: observable,
            object_id: observable,
            object: observable,
            period_from: observable,
            period_to: observable,
            amount: observable,

            billing_count: observable,
            paid_count: observable,
            approved_count: observable,
            unpaid_count: observable,

            total_amount: observable,
            paid_amount: observable,
            debt_amount: observable,
        })
    }

    id = 0
    company_id = 0

    billing_type_id = 0
    billing_type = {}

    name = ''

    object_id = null
    object = {}

    period_from = null
    period_to = null

    amount = 0

    billing_count = 0
    paid_count = 0
    approved_count = 0
    unpaid_count = 0

    total_amount = 0
    paid_amount = 0
    debt_amount = 0
}